import { render, staticRenderFns } from "./DataTemplateConfig.vue?vue&type=template&id=142076f2&scoped=true"
import script from "./DataTemplateConfig.vue?vue&type=script&lang=js"
export * from "./DataTemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./DataTemplateConfig.vue?vue&type=style&index=0&id=142076f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142076f2",
  null
  
)

export default component.exports